<template>
  <div class="live">
    <live-title />
    <super-multi-section></super-multi-section>
  </div>
</template>
<script>
  import SuperMultiSection from '@/components/container/SuperMultiSection'
  import { scrollTop, setDisableScrolling } from '@/common/utils/common'
  import { mapMutations } from 'vuex'
  import { MENU, SET_CURRENT_MENU } from '@/common/resources/const'
  import LiveTitle from '@/components/live/LiveTitle'
  import AlarmPopup from '@/components/mypooq/AlarmPopup'
  export default {
    name: 'app',
    components: {
      AlarmPopup,
      LiveTitle,
      SuperMultiSection
    },
    methods: {
      ...mapMutations([SET_CURRENT_MENU])
    },
    created () {
      scrollTop()
      setDisableScrolling(false)
      this[SET_CURRENT_MENU](MENU.LIVE)
    }
  }
</script>
<style lang="css" src="@/assets/css/common.css"></style>
<style lang="css" src="@/assets/css/base.css"></style>
<style lang="css" src="@/assets/css/live.css"></style>
